/**
 * File: Carousel.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.1
 * Created: 2025-11-16
 * Last Updated: 2025-12-10
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function Carousel({ list }) {
    const listLength = list.length;

    return (
        <>
            <div className="carousel">
                <div className={`carousel__track`}>
                    {list.map((item) => {
                        const Component = item.component;
                        return <Component key={item.id} {...item.props} />;
                    })}
                    {list.map((item) => {
                        const Component = item.component;
                        const id = item.id + "-2";
                        return <Component key={id} {...item.props} />;
                    })}
                </div>
            </div>
        </>
    );
}

export default Carousel;
